<template>
	<div class="invoice-page mx-auto">
		<div class="container-fluid bg-light">
			<div class="row">
				<div class="col">
					<img src="../assets/logo2.png" class="img-logo mb-2" alt="">
				</div>
			</div>
			<div class="row align-items-center">
				<div class="col">
					<p>
						<strong>{{company.name}}</strong>
						<br>
						{{company.address}}
						<br>
						<strong class="text-muted">PIB</strong> {{company.taxNumber}}
						<br>
						<strong class="text-muted">Matični broj</strong> {{company.registrationNumber}}
						<br>
						<strong class="text-muted">Tekući račun</strong> {{company.bankAccount}}
					</p>
				</div>
				<div class="col text-right">
					<p v-if="invoice.client">
						<strong>{{invoice.client.name}}</strong>
						<br>
						{{invoice.client.address}}
						<br>
						<strong class="text-muted">PIB</strong> {{invoice.client.taxNumber}}
						<br>
						<strong class="text-muted">Matični broj</strong> {{invoice.client.registrationNumber}}
					</p>
				</div>
			</div>
			<div class="row align-items-center pt-4">
				<div class="col-7">
					<h1 class="display-number">{{(invoice.type === 'proinvoice') ? 'Predračun' : 'Račun'}} <strong>{{invoice.number}}</strong></h1>
				</div>
				<div class="col-5">
					<p>
						<strong class="text-muted">Datum izdavanja</strong> {{invoice.issueDate | date}}
						<br>
						<strong class="text-muted">Mesto izdavanja</strong> {{invoice.issuePlace}}
						<br>
						<span v-show="invoice.type === 'invoice'"><strong class="text-muted">Datum prometa</strong> {{invoice.deliveryDate | date}}<br></span>
						<strong class="text-muted">Rok za plaćanje</strong> {{invoice.paymentDeadline | date}}
					</p>
				</div>
			</div>
		</div>
		<div class="container-fluid">
			<table class="table">
				<thead class="thead-default">
					<tr>
						<th>Naziv usluge</th>
						<th>Količina</th>
						<th>Cena</th>
						<th class="text-right">Ukupno</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(item, index) in invoice.items">
						<td>{{item.name}}</td>
						<td>{{item.quantity}}</td>
						<td>{{item.price | money}}</td>
						<td class="text-right">{{item.total | money}}</td>
					</tr>
				</tbody>
			</table>

			<h5 class="text-right">Ukupno <span class="badge badge-secondary badge-price">{{invoice.total | money}}</span></h5>

			<div class="text-right pt-3" v-if="advancePayments.length > 0">
				<p class="mb-0">Avansne uplate:</p>
				<ul class="list-inline">
					<li v-for="payment in advancePayments" class="list-inline-item">{{payment.date | date}} <strong>{{payment.amount | money}}</strong></li>
				</ul>
			</div>

			<div class="text-right pt-5" v-show="company.responsiblePerson">
				<p><strong class="text-muted">Odgovorno lice:</strong> {{company.responsiblePerson}}</p>
			</div>

			<div class="text-right pt-1">
				<p class="small" v-show="invoice.note">{{invoice.note}}</p>
				<p class="small text-muted">Račun je punovažan bez pečata i potpisa.<br>Izdavalac računa nije obaveznik PDV-a po članu 33. Zakona o PDV.</p>
			</div>
		</div>

		<footer class="fixed-bottom bg-dark text-light text-center small font-weight-light">
			<div class="container-fluid">
				<div class="row">
					<div class="col">{{company.email}}</div>
					<div class="col"><span>&middot;</span></div>
					<div class="col">{{company.phoneNumber}}</div>
				</div>
			</div>
		</footer>
	</div>
</template>

<script>
import { invoiceStore } from '../stores/invoices';
import { settingStore } from '../stores/settings';
import moment from 'moment';

export default {
	name: 'invoice-page',

	data() {
		return {
			invoice: {},
			company: {}
		};
	},

	computed: {
		advancePayments() {
			if (!this.invoice.payments)
				return [];

			return this.invoice.payments.filter(payment => (payment.date !== null) && moment(payment.date).isBefore(moment(this.invoice.deliveryDate.toDate())));
		}
	},

	created() {
		this.init();
	},

	watch: {
		'$route'(to, from) {
			if (to.name === 'InvoicePreview') {
				if (to.params.id)
					this.load(to.params.id);
			}
			else if (from.name === 'InvoicePreview') {
				this.invoice = {};
				this.company = {};
			}
		}
	},

	methods: {
		init() {
			this.load(this.$route.params.id);
		},

		load(id) {
			let invoice = invoiceStore.get(id);

			if (invoice)
				this.invoice = invoice;
			else {
				this.$toasted.error('Nije uspelo učitavanje fakture.', {
					icon: 'error_outline'
				});
			}

			this.company = settingStore.state.company;
		}
	}
};
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900&subset=latin-ext');

.invoice-page {
	margin: 0;
	padding: 0;
	overflow: hidden;
	position: relative;
 	box-sizing: border-box;
	page-break-after: always;
	font-family: 'Roboto', sans-serif;

	.display-number {
		font-size: 2.5rem;
		font-weight: 300;
		line-height: 1.2;
	}

	.container-fluid {
		padding-left: 20mm;
		padding-right: 20mm;
		padding-top: 10mm;
		padding-bottom: 10mm;
	}

	footer .container-fluid {
		padding-top: 5mm;
		padding-bottom: 5mm;
	}

	.img-logo {
		max-width: 40%;
		height: auto;
	}

	.badge-price {
		font-size: 100%;
	}
}

@media screen {
	.invoice-page {
		background: white;
		box-shadow: 0 .5mm 2mm rgba(0,0,0,.3);
		margin: 5mm;
		width: 210mm;
		height: 296mm;

		> footer {
			position: absolute !important;
		}
	}
}

@media print {
	@page {
		size: A4;
		margin: 0;
	}

	body {
		margin: 0;
		padding: 0;
		min-width: 210mm !important;
	}

	.container-fluid {
		min-width: 210mm !important;
	}

	.badge-price {
		border: 0;
	}
}
</style>



// WEBPACK FOOTER //
// InvoicePreview.vue?9b5e8438